// removed by extract-text-webpack-plugin
module.exports = {"advisory-content-wrap":"advisory-content-wrap","block-advisory":"block-advisory","advisory-img":"advisory-img","advisory-content":"advisory-content","title":"title","phone":"phone","skype":"skype","zalo":"zalo"};


//////////////////
// WEBPACK FOOTER
// ./components/users/sub-view/advisory-content/style.scss
// module id = ./components/users/sub-view/advisory-content/style.scss
// module chunks = 0